// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandWavingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M10.201 30.909a1.502 1.502 0 0 1-2.1.301 16.404 16.404 0 0 1-4.392-4.96 1.5 1.5 0 1 1 2.599-1.5 13.432 13.432 0 0 0 3.59 4.06 1.5 1.5 0 0 1 .303 2.099ZM27.957 12.25A11.5 11.5 0 1 1 8.04 23.75l-4.75-8.227a4 4 0 0 1 2.394-5.857l-.058-.109a4 4 0 0 1 4.5-5.863c.43.116.836.304 1.203.556a4 4 0 0 1 6.547.539L19.44 7.5a4 4 0 0 1 6.267.855l2.25 3.895Zm-2.597 1.5-2.25-3.898a1 1 0 1 0-1.734 1l1.25 2.164a1.5 1.5 0 0 1-.549 2.049 3.501 3.501 0 0 0-1.28 4.781 1.5 1.5 0 1 1-2.6 1.5 6.511 6.511 0 0 1 1.17-7.971L15.28 6.289a1 1 0 1 0-1.732 1l3.25 5.625a1.5 1.5 0 0 1-2.6 1.5l-4.25-7.361a1 1 0 0 0-1.73 1l4.75 8.226a1.501 1.501 0 0 1-2.6 1.5l-2.75-4.763a1.001 1.001 0 1 0-1.73 1l4.75 8.234a8.5 8.5 0 0 0 14.722-8.5Zm4.678-7.899a8.937 8.937 0 0 0-5.465-4.194 1.5 1.5 0 1 0-.777 2.9A5.956 5.956 0 0 1 27.44 7.35a1.5 1.5 0 1 0 2.598-1.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
